<template>
    <div :class="{'main-chart': true, 'chart-vertical': format == 'day'}">
        <div class="main-chart-container">
            <div class="main-chart-column" v-for="(item, index) in chartData" :key="index">
                <div class="main-chart-column-block">
                    <div :class="{'main-chart-column-block-fill': true, 'current-month': item.isCurrent}" :style="{'height': `${chartColumnHeight(item)}%`}">
                        <slot name="value">
                            {{ item.value | shortMoney }}
                        </slot>
                    </div>
                </div>
                <slot name="label">
                    <div class="main-chart-column-label">
                        {{ item.label }}
                    </div>
                </slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "MainChart",

    props: ['chartData', 'format'],

    data: function() {
        return {
            //
        };
    },

    mounted() {
        //
    },

    computed: {
        maxChartValue: function() {
            return this.chartData.reduce(function (a, b) {
                return (parseFloat(a.value) > parseFloat(b.value) ? a : b);
            });
        },

        minChartValue: function() {
            return this.chartData.reduce(function (a, b) {
                return (parseFloat(a.value) < parseFloat(b.value) ? a : b);
            });
        }
    },

    methods: {
        chartColumnHeight(item) {
            let max = this.maxChartValue.value;
            let min = this.minChartValue.value;

            let value = item.value - min;

            if(value == 0) {
                return 0;
            }

            return ((value / (max - min)) * 90) + 10;
        }
    }

}
</script>

<style scoped lang="scss">
.main-chart {
    width: 100%;

    .main-chart-container {
        height: 150px;
        display: flex;
        align-items: flex-end;
        gap: 10px;

        .main-chart-column {
            width: 100%;
            display: flex;
            flex-direction: column;
            justify-content: flex-end;
            height: 100%;

            .main-chart-column-block {
                width: 100%;
                height: 100%;
                display: flex;
                align-items: flex-end;

                .main-chart-column-block-fill {
                    width: 100%;
                    background: #f59c25;
                    display: flex;
                    justify-content: center;
                    align-items: flex-end;
                    border-radius: 5px;
                    transition: 0.5s;
                    height: 50%;
                    font-size: 10px;
                    padding: 2px 0;
                    color: rgba(#fff, 0);

                    &:hover {
                        color: #fff;
                    }
                    
                    &.current-month {
                        background-color: #3F6FB7;
                    }
                }
            }

            .main-chart-column-label {
                text-align: center;
                font-size: 13px;
                padding: 5px;
                color: #152640;
            }
        }
    }

    &.chart-vertical {
        .main-chart-container {
            height: 175px;

            .main-chart-column {
                .main-chart-column-label {
                    writing-mode: vertical-lr;
                    text-orientation: mixed;
                    height: 50px;
                    font-size: 12px;
                }
            }
        }
    }
}
</style>